import React from "react";

function VideoPlayMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="55"
      height="55"
      viewBox="0 0 55 55"
    >
      <g id="play" transform="translate(0.159 0.249)">
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="27.5"
          cy="27.5"
          r="27.5"
          transform="translate(-0.159 -0.249)"
          opacity="0.7"
        />
        <path
          id="Play_Icon"
          data-name="Play Icon"
          d="M23.61,15.387l-14.544,9.7A.686.686,0,0,1,8,24.512V5.12A.686.686,0,0,1,9.067,4.55l14.544,9.7a.686.686,0,0,1,0,1.142Z"
          transform="translate(11.383 12.539)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default VideoPlayMobile;
